(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hm-cards"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hm-faq-search')) {
  /**
   * HALO & MOI — filtre instantané des questions de FAQ de la page.
   * Sans JavaScript, le formulaire envoie vers la recherche Shopify.
   */
  class HmFaqSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.status = this.querySelector('[data-hm-search-status]');
      this.form = this.querySelector('form');
      if (!this.input) return;
      this.input.addEventListener('input', () => this.filter());
      this.form?.addEventListener('submit', (event) => {
        const items = this.items();
        if (!items.length) return;
        event.preventDefault();
        this.filter();
        const first = items.find((item) => !item.hidden);
        (first || items[0]).closest('[data-hm-faq-list]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    items() {
      return Array.from(document.querySelectorAll('[data-hm-faq-item]'));
    }

    normalize(value) {
      return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    filter() {
      const query = this.normalize(this.input.value.trim());
      let visible = 0;
      for (const item of this.items()) {
        const match = !query || this.normalize(item.textContent).includes(query);
        item.hidden = !match;
        if (match) visible += 1;
        if (query && match && visible === 1) item.open = true;
      }
      document.querySelectorAll('[data-hm-faq-empty]').forEach((el) => {
        el.hidden = visible > 0;
      });
      if (this.status) this.status.textContent = query ? `${visible} question(s) trouvée(s)` : '';
    }
  }
  customElements.define('hm-faq-search', HmFaqSearch);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-ugc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hm-carousel')) {
  /** HALO & MOI — flèches précédent / suivant pour une piste en scroll-snap. */
  class HmCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-hm-track]');
      this.prev = this.querySelector('[data-hm-prev]');
      this.next = this.querySelector('[data-hm-next]');
      if (!this.track) return;
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }

    go(direction) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      if (this.prev) this.prev.disabled = scrollLeft <= 2;
      if (this.next) this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }
  customElements.define('hm-carousel', HmCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
